var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40064 4.40064C4.93483 3.86645 5.80092 3.86645 6.33511 4.40064L12 10.0656L17.6649 4.4007C18.1991 3.86651 19.0652 3.86651 19.5994 4.4007C20.1335 4.93488 20.1335 5.80097 19.5994 6.33516L13.9345 12L19.5993 17.6648C20.1335 18.199 20.1335 19.0651 19.5993 19.5993C19.0651 20.1335 18.199 20.1335 17.6648 19.5993L12 13.9345L6.33517 19.5994C5.80098 20.1335 4.93489 20.1335 4.4007 19.5994C3.86651 19.0652 3.86651 18.1991 4.4007 17.6649L10.0656 12L4.40064 6.33511C3.86645 5.80092 3.86645 4.93483 4.40064 4.40064Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.077a98946a4c4bb4abedc64936ad8dbe.svg";
export { ForwardRef as ReactComponent };